import $ from 'jquery';
import Viewport from './Viewport';
import 'slick-carousel';

const defaults = {
  container: '.view-content',
  speed: 250,
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 768,
      settings: 'unslick',
    },
  ],
};

export default class Connect {
  constructor(element, options) {
    this.settings = Object.assign(defaults, options);
    this.element = element;
    this.$element = $(element);
    this.$instance = this.getInstance();
    this.$instance.slick(this.settings);
    // this.listen();
    // this.update();
    this.ready();
  }

  listen() {
    Viewport.onChange(this.update.bind(this));
  }

  update() {
    if (Viewport.mobileState) {
      this.build();
    } else {
      this.destroy();
    }
  }

  getInstance() {
    return this.$element.find(this.settings.container);
  }

  build() {
    if (this.$instance.not('.slick-initialized')) {
      this.$instance.slick(this.settings);
    }
  }

  destroy() {
    if (this.$instance.is('.slick-initialized')) {
      this.$instance.slick('unslick');
    }
  }

  ready() {
    this.$element.addClass('ready');
  }
}
